export default function commentThreadHash(threadId: string) {
  return `#thread-${threadId}`;
}
